module.exports = __webpack_public_path__ + "images/index/img06-6.d8c27fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/proimg/kua/img06-6.jpg
// module id = 7y+V
// module chunks = 21